import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from '../features/auth/pages/Login';
import Home from '../features/home/pages/Home/Home';
import ResetPassword from '../features/auth/pages/ResetPassword';
import Dashboard from '../features/dashboard/pages/Dashboard/Dashboard';
import DashboardCiudadano from '../pages/Ciudadano/DashboardCiudadano/DashboardCiudadano';
import Interoperability from '../features/interoperability/pages/Interoperability/Interoperability';
import Audits from '../features/audits/pages/Audits/Audits';
import CertificatesValidation from '../features/certificates-validation/pages/CertificatesValidation/CertificatesValidation';
import UsersManagement from '../features/users/pages/UsersManagement/UsersManagement';
import MyProfile from '../features/profile/pages/MyProfile/MyProfile';
import Reports from '../features/reports/pages/Reports/Reports';
import Dependencies from '../features/dependencies/pages/Dependencies/Dependencies';
import Roles from '../features/roles/pages/Roles/Roles';
import NotFound from '../pages/NotFound/NotFound';
//import Onboarding from '../features/onboarding/pages/Onboarding/Onboarding';
import Onboarding from '../features/users/components/Onboarding/Onboarding';
import DashboardFuncionario from '../pages/Funcionario/FuncionarioDashboard/FuncionarioDashboard';
import AiAssistant from '../features/ai-assistant/pages/AiAssistant/AiAssistant';
import SystemConfigurations from '../features/system-configurations/pages/SystemConfigurations/SystemConfigurations';
import Datamart from '../features/datamart/pages/Datamart/Datamart';
import ProtectedRoutes from './ProtectedRoutes';
import CertificateTypes from '../features/certificate-types/pages/CertificateTypes/CertificateTypes';
import CertificateConfiguration from '../features/xsd/pages/CertificateConfiguration';
import CertificateBuilderPage from '../features/CertificateBuilder/CertificateBuilderPage';
import CadastralPage from '../features/cadastral/pages/CadastralPage/CadastralPage';
import Monitoring from '../features/monitoring/pages/Monitoring/Monitoring';
import Emissions from '../features/emission/pages/Emissions/Emissions';
import Validate from '../features/certificates-validation/components/Validate/Validate';
import ProtectedRoute from '../components/ProtectedRoute';
import AccessDenied from '../components/AccessDenied';
import { ENUM_PERMISSIONS, ENUM_ROLES } from '../interaces/enums/enums.interface';
function AppRoutes() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Rutas Públicas */}
        <Route path="*" element={<NotFound />} />
        <Route path="/" element={<Login />} />
        <Route path="/onboarding" element={<Onboarding />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/validate" element={<Validate />} />
        <Route path="/access-denied" element={<AccessDenied />} />
        <Route path="/myProfile" element={<MyProfile />} />

        {/* Rutas Protegidas (Requieren autenticación) */}
        <Route element={<ProtectedRoutes />}>
          <Route path="/home" element={<Home />} />

          <Route element={<ProtectedRoutes allowedRoles={[ENUM_ROLES.SUPERADMIN]} />}>
            <Route path="/dashboard" element={<Dashboard />} />
          </Route>
          <Route element={<ProtectedRoute permission={ENUM_PERMISSIONS.MOD_EMISSION_READ} />}>
            <Route path="/emissions" element={<Emissions />} />{' '}
          </Route>
          <Route
            element={
              <ProtectedRoute
                permission={[
                  ENUM_PERMISSIONS.MOD_INTEROP_SERVICES_READ,
                  ENUM_PERMISSIONS.MOD_INTEROP_METRICS_READ,
                  ENUM_PERMISSIONS.MOD_INTEROP_HISTORY_READ,
                ]}
              />
            }
          >
            <Route path="/interoperability" element={<Interoperability />} />
          </Route>
          <Route element={<ProtectedRoute permission={ENUM_PERMISSIONS.MOD_AUDIT_READ} />}>
            <Route path="/audits" element={<Audits />} />
          </Route>
          <Route path="/certificates-validation" element={<CertificatesValidation />} />
          <Route
            element={
              <ProtectedRoute
                permission={[
                  ENUM_PERMISSIONS.MOD_USERS_MANAGEMENT_READ,
                  ENUM_PERMISSIONS.MOD_USERS_INVITATIONS_READ,
                ]}
              />
            }
          >
            <Route path="/users-management" element={<UsersManagement />} />
          </Route>
          {/* <Route
            element={<ProtectedRoute permission={ENUM_PERMISSIONS.MOD_USERS_MANAGEMENT_READ} />}
          >
            <Route path="/myProfile" element={<MyProfile />} />
          </Route> */}
          <Route element={<ProtectedRoute permission={ENUM_PERMISSIONS.MOD_REPORTS_READ} />}>
            <Route path="/reports" element={<Reports />} />
          </Route>
          <Route element={<ProtectedRoute permission={ENUM_PERMISSIONS.MOD_ROLES_READ} />}>
            <Route path="/roles" element={<Roles />} />
          </Route>
          <Route element={<ProtectedRoute permission={ENUM_PERMISSIONS.MOD_DEPENDENCIES_READ} />}>
            <Route path="/dependencies" element={<Dependencies />} />
          </Route>
          <Route element={<ProtectedRoute permission={ENUM_PERMISSIONS.MOD_REPORTS_READ} />}>
            <Route path="/dashboardciudadano" element={<DashboardCiudadano />} />
          </Route>
          <Route element={<ProtectedRoute permission={ENUM_PERMISSIONS.MOD_REPORTS_READ} />}>
            <Route path="/dashboardfuncionario" element={<DashboardFuncionario />} />
          </Route>
          <Route element={<ProtectedRoute permission={ENUM_PERMISSIONS.MOD_AI_READ} />}>
            <Route path="/ia-assistant" element={<AiAssistant />} />
          </Route>
          <Route
            element={
              <ProtectedRoute
                permission={[
                  ENUM_PERMISSIONS.MOD_SYSTEM_CONFIGURATION_COLORS_READ,
                  ENUM_PERMISSIONS.MOD_SYSTEM_CONFIGURATION_SMTP_READ,
                  ENUM_PERMISSIONS.MOD_SYSTEM_CONFIGURATION_RENAPO_READ,
                ]}
              />
            }
          >
            <Route path="/system-configurations" element={<SystemConfigurations />} />
          </Route>
          <Route
            element={
              <ProtectedRoute
                permission={[
                  ENUM_PERMISSIONS.MOD_CERTIFICATE_CONFIGURATION_TYPE_READ,
                  ENUM_PERMISSIONS.MOD_CERTIFICATE_CONFIGURATION_XSD_READ,
                  ENUM_PERMISSIONS.MOD_CERTIFICATE_CONFIGURATION_PDF_READ,
                ]}
              />
            }
          >
            <Route path="/certificate-configuration" element={<CertificateConfiguration />} />
          </Route>
          <Route
            element={
              <ProtectedRoute
                permission={[
                  ENUM_PERMISSIONS.MOD_CERTIFICATE_CONFIGURATION_TYPE_READ,
                  ENUM_PERMISSIONS.MOD_CERTIFICATE_CONFIGURATION_XSD_READ,
                  ENUM_PERMISSIONS.MOD_CERTIFICATE_CONFIGURATION_PDF_READ,
                ]}
              />
            }
          >
            <Route path="/certificate-builder" element={<CertificateBuilderPage />} />
          </Route>
          <Route
            element={
              <ProtectedRoute
                permission={[
                  ENUM_PERMISSIONS.MOD_CERTIFICATE_CONFIGURATION_TYPE_READ,
                  ENUM_PERMISSIONS.MOD_CERTIFICATE_CONFIGURATION_XSD_READ,
                  ENUM_PERMISSIONS.MOD_CERTIFICATE_CONFIGURATION_PDF_READ,
                ]}
              />
            }
          >
            <Route path="/certificate-types" element={<CertificateTypes />} />
          </Route>
          <Route element={<ProtectedRoute permission={ENUM_PERMISSIONS.MOD_CATASTRO_READ} />}>
            <Route path="/cadastral" element={<CadastralPage />} />
          </Route>
          <Route element={<ProtectedRoute permission={ENUM_PERMISSIONS.MOD_DATAMART_READ} />}>
            <Route path="/datamart" element={<Datamart />} />
          </Route>
          <Route element={<ProtectedRoute permission={ENUM_PERMISSIONS.MOD_AUDIT_READ} />}>
            <Route path="/monitoring" element={<Monitoring />} />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default AppRoutes;
